import { action } from "@storybook/addon-actions";

export const navigatorLogger = {
    navigate(r: object) {
        action(`navigator.navigate`)(r);
    },
    dispatch(r: object) {
        action(`navigator.dispatch`)(r);
    },
    goBack() {
        action(`navigator.goBack`)();
    },
};
